import { SECOND } from '~/constants/date';
import { WebsocketHandlerType } from '~/stores/actions/WebsocketActions';
import { getReconnectDelay } from '~/utils/dateUtil';
import { generateRandomNumber } from '~/utils/fnUtil/fnUtil';
import { action, observable } from 'mobx';

class WebsocketStore {
  @observable preventReconnectingDurationMs = 0;
  @observable disableReconnect = false;
  @observable reconnectStartTime = 0;
  @observable reconnectRemainTime = 0;
  @observable reconnectIntervalId = 0;
  preventReconnectTimer = 0;

  constructor(public type: WebsocketHandlerType) {}

  @action
  setPreventReconnectingDurationMs = (duration: number) => {
    window.clearTimeout(this.preventReconnectTimer);
    if (duration === 0) {
      this.preventReconnectingDurationMs = 0;
      return;
    }
    this.preventReconnectingDurationMs = duration + this.generateRandomConnectMs();
    this.preventReconnectTimer = window.setTimeout(this.clearPreventReconnectingDurationMs, duration);
  };

  @action
  clearPreventReconnectingDurationMs = () => {
    this.preventReconnectingDurationMs = 0;
  };

  @action
  setDisableReconnect = (value: boolean) => {
    this.disableReconnect = value;
  };

  @action
  setReconnectStartTime = (value: number) => {
    this.reconnectStartTime = value;
  };

  @action
  setReconnectRemainTime = (value: number) => {
    this.reconnectRemainTime = value;
  };

  @action
  setReconnectIntervalId = (value: number) => {
    this.reconnectIntervalId = value;
  };

  public setNextReconnectTime = () => {
    getReconnectDelay(this.reconnectStartTime).map(this.setReconnectRemainTime);
  };

  @action
  public clearReconnect = () => {
    this.reconnectStartTime = 0;
    this.setDisableReconnect(false);
    window.clearInterval(this.reconnectIntervalId);
    this.reconnectIntervalId = 0;
    this.setReconnectRemainTime(0);
  };

  private generateRandomConnectMs = () => {
    return Math.round(generateRandomNumber(10, 600)) * SECOND;
  };

  public startReconnectInterval = (reconnect: () => void) => {
    if (this.reconnectIntervalId) {
      return;
    }
    const intervalId = window.setInterval(() => {
      if (this.reconnectRemainTime > 0) {
        this.setReconnectRemainTime(this.reconnectRemainTime - SECOND);
      } else {
        reconnect();
      }
    }, SECOND);
    this.setReconnectIntervalId(intervalId);
  };
}

export default WebsocketStore;

export const websocketStore = new WebsocketStore(WebsocketHandlerType.Default);
export const interTenantWebsocketStore = new WebsocketStore(WebsocketHandlerType.InterTenant);
